<script>
    import currencyFormatter from 'currency-formatter';
    import svgIcons from './svg';

    export default {
        name: 'PropertyMixin',
        data() {
            return {}
        },
        computed: {
            propertyTitle() {
                return this.property && this.property.title.rendered;
            },
            propertyImage() {
                return this.property && this.property.featured_media;
            },
            propertyAddressOverride() {
                return this.property && this.property.acf.property_address_override;
            },
            propertyAddress() {
                return this.propertyAddressOverride || this.property && this.property.acf && this.property.acf.location.address;
            },
            getBedrooms() {
                return this.property && this.property.acf.apartment_types.map((bed) => bed === "0" ? 'Studio' : bed === "30" ? 'Townhouse' : bed === "31" ? 'Den' : `${bed} Bed`);
            },
            propertyTypes() {
                return this.property && this.getBedrooms.join(' | ');
            },
            propertyFromPrice() {
                return this.property && `From ${this.formatCurrencyAmount(this.property.acf.price_range_min)}`;
            },
            getAvailability() {
                if (!this.enabled_api)
                    return false;

                return this.property && this.property.units;
            },
            propertyAvailability() {
                if (!this.getAvailability)
                    return '';

                let plural = this.getAvailability === 1 ? 'Unit' : 'Units';
                return this.property && `${this.getAvailability || 0} ${plural} Available`;
            },
            amenitiesSvg() {
                return wp.amenities_svg;
            },
            getAmenities() {
                return this.property && this.property.acf.amenities_list && this.property.acf.amenities_list.map((amenity) => {
                    return {
                        svg: this.amenitiesSvg[amenity.value]
                    }
                });
            },
            propertyAmenities() {
                return this.property && this.property.acf.amenities_list && this.getAmenities.map((amenity) => amenity.svg).join(' ');
            },
            tooltipImageBackground() {
                if (!this.imageUrl)
                    return '';

                return `background-image: url(${this.imageUrl})`;
            },
            imageUrl() {
                return this.property && this.property.acf && this.property.acf.property_view_image && this.property.acf.property_view_image.url;
            },
            propertyUrl() {
                return this.property && this.property.acf && this.property.acf.property_url;
            },
            enabled_api() {
                return this.property && this.property.acf && this.property.acf.enabled_api;
            }
        },
        methods: {
            formatCurrencyAmount(amount) {
                return currencyFormatter.format(amount, {
                    code: 'USD',
                    symbol: '$',
                    thousandsSeparator: ',',
                    decimalSeparator: '.',
                    symbolOnLeft: true,
                    precision: 0,
                    spaceBetweenAmountAndSymbol: false,
                    decimalDigits: 0,
                });
            },
            imageLoaded() {
                this.$emit('imageLoaded');
            },
        }
    }

</script>
<style lang="scss" type="text/scss">
    .property-amenities {
        svg {
            display: inline-block;
            vertical-align: middle;
            height: 15px;
            fill: #808080;

            path{
                fill: #808080;
            }
        }
    }

    .ie {
        .property-amenities {
            svg {
                max-width: 20px;
            }
        }
    }
</style>

<style lang="scss" type="text/scss" scoped>

    .property-title {
        margin-bottom: 0;
        margin-top: 15px;
        font-size: 18px;
    }

    address.address, .property-type {
        font-style: normal;
        font-size: 12px;
        color: #808080;
    }

    .property-image {
        max-width: 100%;
        height: auto;
    }

    .property-price {
        color: #EE811F;
        font-weight: 700;
        font-size: 14px;
    }

    .wrap-price {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .property-item {
        margin-bottom: 25px;
        position: relative;
        overflow: hidden;

        .overlay {
            background-color: rgba(#EE811F, .9);
            color: #fff;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            pointer-events: none;
            transition: all .3s ease-in-out;

            div {
                position: absolute;
                width: calc(100% - 30px);
                height: calc(100% - 30px);
                left: 15px;
                top: 15px;
                border: 1px solid #fff;

                span {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    text-align: center;
                    width: 100%;
                }
            }
        }

        &:hover {
            .overlay {
                opacity: 1;
                pointer-events: all;
            }
        }
    }

    .availability {
        text-align: center;
        font-size: 13px;
        color: #6EB71D;
        border-bottom: 2px solid;
        padding-bottom: 5px;
    }

</style>
